<template>
  <span
    v-accessibility-focus="() => callAction(event)"
    class="o-typography__label o-button__label"
  >
    {{ event.title }}
  </span>
</template>
<script>
  import { clearEvents, setSeekTo } from '@/shared/components/player/store';
  import { TimelineEventAction } from '@/shared/components/player/enums';

  export default {
    name: 'UiDefaultAction',
    props: {
      event: Object,
    },
    methods: {
      callAction(event) {
        this[event.action](event);
      },
      [TimelineEventAction.SKIP_INTRO](event) {
        setSeekTo(event.till);
      },
      [TimelineEventAction.WATCH_CREDITS]() {
        clearEvents();
      },
    },
  };
</script>
